export const geoAreaGermanLocalization = {
  screens: {
    myRegion: {
      conveniences: 'Dienste',
      volunteering: 'Ehrenamt',
      entertainment: 'Unterhaltung',
      partner: 'Regionale Partner der App',
      withinYourRegion: 'In deiner Region',
      all: 'Alle',
      empty: {
        conveniences: 'Praktischer Dienst für die Region?\nZeig ihn hier!',
        volunteering:
          'Teil einer ehrenamtlichen Organisation?\nLass sie hier eintragen!',
        entertainment:
          'Teil einer Unterhaltungsorganisation?\nLass sie hier eintragen!',
        partner: 'Regionale Partner gesucht - macht mit!',
        profile:
          'Dieser Ort ist noch nicht beschrieben. Erfahre, wie deine Kommune das ändern kann.',
        more: 'Mehr erfahren'
      },
      tabs: {
        ministries: 'Ministerien',
        regionalRadio: 'Regionalfunk',
        emergency: 'Blaulicht',
        events: 'Events'
      },
      filters: {
        all: 'Alle',
        police: 'Polizei',
        fireBrigade: 'Feuerwehr',
        redCross: 'Rotes Kreuz',
        waterRescue: 'Wasserwacht',
        radiusKm: 'Umkreis {{radiusKm}} km'
      },
      fab: {
        marktplatz: 'Marktplatz-Angebot',
        event: 'Neues Event',
        umfrage: 'Umfrage',
        beitrag: 'Beitrag'
      }
    },
    'geo-area-subscription': {
      map: {
        title: 'Dein Ort',
        description: 'Wähle deinen Heimatort',
        searchPlaceholder: 'Suche nach PLZ oder Name',
        button: 'Übernehmen',
        map: 'Wähle den Umkreis, der dich interessiert'
      },
      preview: {
        count_one: '{{count}} Ort in Reichweite',
        count_other: '{{count}} Orte in Reichweite'
      }
    },
    'my-radius': {
      title: 'Meine Region & Radius',
      description:
        'Lege fest, wie weit „Meine Region" reicht. Bestimmt, welche Umland-Gemeinden, Landkreise und Bezirke einfließen.',
      sliderLabel: 'Regionalfunk',
      value: '{{km}} km',
      mapHint: 'Ziehe den Regler, um den Umkreis anzupassen',
      preview: {
        count_one: '{{count}} Ort in Reichweite',
        count_other: '{{count}} Orte in Reichweite',
        noHomeArea:
          'Lege zuerst einen Heimatort unter „Heimatort & Umkreis" fest.'
      },
      save: 'Übernehmen'
    },
    'organization-profile': {
      about: 'Über uns',
      facts: 'In Zahlen',
      people: 'Vorsitz',
      state: {
        loading: { title: 'Profil wird geladen' },
        error: {
          title: 'Organisation konnte nicht geladen werden',
          subtitle: 'Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
        }
      }
    },
    'convenience-profile': {
      buttonDefaultText: 'Zur Webseite',
      state: {
        loading: { title: 'Profil wird geladen' },
        error: {
          title: 'Dienst konnte nicht geladen werden',
          subtitle: 'Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
        }
      }
    }
  },
  components: {
    search: {
      placeholder: 'Suche nach PLZ oder Name',
      location: 'Automatisch ermitteln (Standortfreigabe)',
      resultsHint: {
        locationDescription:
          'Deine Kommune ist nicht dabei? Ort automatisch bestimmen'
      },
      state: {
        empty: {
          subtitle:
            'Wir konnten deinen Ort nicht finden.\nBitte überprüfe die Eingabe.',
          footer: 'Dein Ort fehlt?'
        }
      }
    },
    searchBar: {
      clear: 'Suche löschen',
      clearHint: 'Setzt die aktuelle Ortsauswahl zurück'
    },
    regionPartnersSheet: {
      title: 'Regionale Partner',
      empty: 'In dieser Region sind noch keine Partner eingetragen.',
      state: {
        error: {
          title: 'Partner konnten nicht geladen werden',
          subtitle: 'Bitte versuche es zu einem späteren Zeitpunkt erneut.',
          retry: 'Erneut versuchen'
        }
      }
    }
  },
  geoAreaTypeLabels: {
    NATION: 'Land',
    FEDERAL_STATE: 'Bundesland',
    COUNTY: 'Landkreis',
    ASSOCIATION_OF_MUNICIPALITIES: 'Verbandsgemeinde',
    MUNICIPALITY: 'Kommune',
    CITY: 'Stadt',
    CITY_DISTRICT: 'Stadtteil',
    UNKNOWN: 'Unbekannt'
  }
};

// Guarantees that both translations have the same structure
type GeoAreaLocalization = typeof geoAreaGermanLocalization;

export const geoAreaEnglishLocalization: GeoAreaLocalization = {
  screens: {
    myRegion: {
      conveniences: 'Services',
      volunteering: 'Volunteering',
      entertainment: 'Entertainment',
      partner: 'Regionale Partner needed - take part!',
      withinYourRegion: 'Within your region',
      all: 'All',
      empty: {
        conveniences: 'Useful service for the area?\nShow it here!',
        volunteering: 'Part of a volunteer organization?\nRegister it here!',
        entertainment:
          'Part of an entertainment organization?\nRegister it here!',
        partner: 'Regional partners will be shown here.',
        profile:
          'This place is not yet described. Learn how your municipality can change that.',
        more: 'Learn more'
      },
      tabs: {
        ministries: 'Ministries',
        regionalRadio: 'Regional radio',
        emergency: 'Public Safety',
        events: 'Events'
      },
      filters: {
        all: 'All',
        police: 'Police',
        fireBrigade: 'Fire brigade',
        redCross: 'Red Cross',
        waterRescue: 'Water rescue',
        radiusKm: 'Radius {{radiusKm}} km'
      },
      fab: {
        marktplatz: 'Marketplace offer',
        event: 'New event',
        umfrage: 'Poll',
        beitrag: 'Post'
      }
    },
    'geo-area-subscription': {
      map: {
        title: 'Your Home Area',
        description: 'Choose your home area',
        searchPlaceholder: 'Search for postal code or name',
        button: 'Save',
        map: 'Select the area of interest'
      },
      preview: {
        count_one: '{{count}} place in range',
        count_other: '{{count}} places in range'
      }
    },
    'my-radius': {
      title: 'My Region & Radius',
      description:
        'Set how far "My Region" reaches. Determines which surrounding municipalities and districts flow in.',
      sliderLabel: 'Regional radio',
      value: '{{km}} km',
      mapHint: 'Drag the slider to adjust the radius',
      preview: {
        count_one: '{{count}} place in range',
        count_other: '{{count}} places in range',
        noHomeArea:
          'First set a home area under "Home town & surrounding area".'
      },
      save: 'Apply'
    },
    'organization-profile': {
      about: 'About us',
      facts: 'In numbers',
      people: 'Responsible',
      state: {
        loading: { title: 'Profile is loading' },
        error: {
          title: 'Organization could not be loaded',
          subtitle: 'Please try again later'
        }
      }
    },
    'convenience-profile': {
      buttonDefaultText: 'Go to website',
      state: {
        loading: { title: 'Profile is loading' },
        error: {
          title: 'Service could not be loaded',
          subtitle: 'Please try again later'
        }
      }
    }
  },
  components: {
    search: {
      placeholder: 'Search for postal code or name',
      location: 'Automatically determine (location sharing)',
      resultsHint: {
        locationDescription:
          'Your municipality is not listed? Determine your location automatically'
      },
      state: {
        empty: {
          subtitle: "We couldn't find your location.\nPlease check your input.",
          footer: 'Is your location missing?'
        }
      }
    },
    searchBar: {
      clear: 'Clear search',
      clearHint: 'Resets the current location selection'
    },
    regionPartnersSheet: {
      title: 'Regional partners',
      empty: 'No partners are registered in this region yet.',
      state: {
        error: {
          title: 'Partners could not be loaded',
          subtitle: 'Please try again later.',
          retry: 'Try again'
        }
      }
    }
  },
  geoAreaTypeLabels: {
    NATION: 'Country',
    FEDERAL_STATE: 'Federal state',
    COUNTY: 'District',
    ASSOCIATION_OF_MUNICIPALITIES: 'Association of municipalities',
    MUNICIPALITY: 'Municipality',
    CITY: 'City',
    CITY_DISTRICT: 'City district',
    UNKNOWN: 'Unknown'
  }
};
